import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { AbsenceSalarieDto } from "../../../dto/GenApi.iNotPaie.Dto/AbsenceSalarieDto";
import { ActionAbsencesEnum } from "../../../dto/GenApi.iNotPaie.Dto/ActionAbsencesEnum";
import ModalChangerEtatAbsence from "../modals/modalChangerEtatAbsence/modalChangerEtatAbsence";

@Component({
	components: {
		EspaceSalarie: require("./espaceSalarie/espaceSalarie.vue.html"),
		EspaceManager: require("./espaceManager/espaceManager.vue.html")
	}
})
export default class ListeDesDemandes extends Vue {

	@Prop()
	public modalChangerEtatAbsence?: ModalChangerEtatAbsence = undefined;

	@Prop()
	public isModeManager = false;

	public fetchData(): void {
    	const espaceSalarie: any = this.$children[0];
    	espaceSalarie.fetchData();

    	const espaceManager: any = this.$children[1];
    	espaceManager.fetchData();
	}

	public afficherModalSupprimerAbsence(data: any): void {
    	const absence = data.absence;
    	const estValide = data.estValide;
    	const annulerAnnulation = data.annulerAnnulation;
    	this.$emit("afficherModalSupprimerAbsence", { absence, estValide, annulerAnnulation });
	}

	public afficherModalChangerEtatAbsence(absence: AbsenceSalarieDto, action: ActionAbsencesEnum): void {
		this.$emit("afficherModalChangerEtatAbsence", absence, action);
	}

	public afficherModalAjouterAbsence(): void {
    	this.$emit("afficherModalAjouterAbsence");
	}

	public afficherModalValiderAbsence(data: any): void {
    	const absence = data.absence;
    	const state = data.state;
    	const modeAnnulation = data.modeAnnulation;
    	this.$emit("afficherModalValiderAbsence", { absence, state, modeAnnulation });
	}

	public afficherModalDetailAbsence(data: any): void {
    	const absence = data.absence;
    	this.$emit("afficherModalDetailAbsence", { absence });
	}
}



// WEBPACK FOOTER //
// ./src/components/gestionDesAbsences/listeDesDemandes/listeDesDemandes.ts